import { render, staticRenderFns } from "./ReceptionBoxSelect.vue?vue&type=template&id=ed31e414"
import script from "./ReceptionBoxSelect.vue?vue&type=script&lang=js"
export * from "./ReceptionBoxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports